import axios from "axios";
import { getTokenGetter } from "./authToken";

const API_BASE = process.env.REACT_APP_API_URL;

const axiosConfig = axios.create({
  baseURL: `${API_BASE}`,//"http://localhost:8080", //  
  headers: { "Content-Type": "application/json" },
});

axiosConfig.interceptors.request.use(
  async (config) => {
    const getter = getTokenGetter();
    if (getter) {
      const token = await getter();

      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }else{
       console.log("No token getter set (user not authenticated yet).");

    }
    return config;
  },
  (error) => Promise.reject(error)
);


export default axiosConfig;
